const openAgeGroupDialog = ids => ({
  type: 'PUPILS:DIALOG:SET_AGE_GROUP_OPEN',
  ids
})
const closeAgeGroupDialog = () => ({
  type: 'PUPILS:DIALOG:SET_AGE_GROUP_CLOSE'
})

export { openAgeGroupDialog, closeAgeGroupDialog }
